import React, { useState } from "react";

export default function CourseFaqs({ course }) {
const [openFaq, setOpenFaq] = useState(0);

const faqs = course?.faqs;

return (
<section id="course-faqs" className="relative overflow-hidden bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">
  <div className="container relative z-[1] mx-auto">

    <div className="grid gap-12 lg:grid-cols-[390px_1fr] lg:gap-20">

      {/* LEFT */}
      <div className="lg:sticky lg:top-[160px] lg:self-start">
        <span className="text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
          Questions, Answered
        </span>

        <h2
          className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.5vw,62px)] font-normal leading-[1.04] tracking-[-0.04em] text-[#071A2F]">
          FAQs About{" "}
          <em className="block font-normal text-[#8B1E3F]">
            {course?.shortTitle || course?.title || "This Programme"}
          </em>
        </h2>

        <p className="mt-6 max-w-[350px] text-[15px] leading-7 text-[#69747E]">
          Find answers to common questions about studying this programme,
          eligibility, learning and future opportunities.
        </p>

        <div className="mt-10 border-l-2 border-[#8B1E3F] pl-6">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
            Still have a question?
          </span>

          <p className="mt-3 text-sm leading-6 text-[#071A2F]/65">
            Our admissions team can help you understand the programme
            before you apply.
          </p>

          <a href="/contact" className="group mt-5 inline-flex items-center gap-5 text-sm font-bold text-[#071A2F]">
            Ask Admissions
            <span className="text-[#8B1E3F] transition-transform group-hover:translate-x-1">
              →
            </span>
          </a>
        </div>
      </div>

      {/* RIGHT */}
      <div className="border-t border-[#071A2F]/15">
        {faqs.map((item, index) => {
        const isOpen = openFaq === index;

        return (
        <article key={item.question} className="border-b border-[#071A2F]/15">
          <button type="button" onClick={()=> setOpenFaq(isOpen ? -1 : index)}
            aria-expanded={isOpen}
            className="group grid w-full grid-cols-[42px_1fr_44px] items-start gap-4 py-7 text-left
            sm:grid-cols-[55px_1fr_48px] sm:py-8"
            >
            <span className="pt-1 text-xs font-bold tracking-[0.12em] text-[#8B1E3F]/55">
              {String(index + 1).padStart(2, "0")}
            </span>

            <span
              className="font-['Libre_Caslon_Display',Georgia,serif] text-[22px] font-normal leading-[1.3] text-[#071A2F] transition-colors group-hover:text-[#8B1E3F] sm:text-[25px]">
              {item.question}
            </span>

            <span className={` grid h-11 w-11 place-items-center rounded-full border text-xl transition-all duration-300
              ${ isOpen ? "rotate-45 border-[#8B1E3F] bg-[#8B1E3F] text-white" : "border-[#071A2F]/15 text-[#8B1E3F]" }
              `}>
              +
            </span>
          </button>

          <div className={`grid transition-all duration-300 ${ isOpen ? "grid-rows-[1fr] opacity-100"
            : "grid-rows-[0fr] opacity-0" }`}>
            <div className="overflow-hidden">
              <div className="grid grid-cols-[42px_1fr_44px] gap-4 pb-8 sm:grid-cols-[55px_1fr_48px]">
                <span />

                <p className="max-w-[760px] text-[15px] leading-8 text-[#68737D]">
                  {item.answer}
                </p>

                <span />
              </div>
            </div>
          </div>
        </article>
        );
        })}
      </div>
    </div>
  </div>
</section>
);
}